import { fromPromise } from 'xstate';
import { apolloClient } from '@/lib/apollo';
import { PublishScheduleMutation, ViewAvailableSchedulesQuery } from '@/lib/gql/__generated__/canonical-documents';
import type { PublishScheduleInput, ViewAvailableSchedulesQueryQuery } from '@/lib/gql/__generated__/graphql';

export type AvailableSchedule = NonNullable<
  NonNullable<ViewAvailableSchedulesQueryQuery['viewAvailableSchedules']['schedules']>[number]
>;

export const viewAvailableSchedulesActor = fromPromise<AvailableSchedule[], void>(async () => {
  const { data } = await apolloClient.query({ query: ViewAvailableSchedulesQuery, fetchPolicy: 'network-only' });
  if (!data) throw new Error('Available schedules could not be loaded.');

  return (
    data.viewAvailableSchedules.schedules?.filter((schedule): schedule is AvailableSchedule => schedule !== null) ?? []
  );
});

export const publishScheduleActor = fromPromise<void, Omit<PublishScheduleInput, 'scheduleId'>>(async ({ input }) => {
  const { data } = await apolloClient.mutate({
    mutation: PublishScheduleMutation,
    variables: {
      input: {
        scheduleId: crypto.randomUUID(),
        route: input.route,
        direction: input.direction,
        serviceDay: input.serviceDay,
        tripId: input.tripId,
        stopId: input.stopId,
        stopName: input.stopName,
        scheduledTime: input.scheduledTime,
        tripDestination: input.tripDestination,
      },
    },
  });

  if (!data) throw new Error('Schedule could not be published.');
  if (!data.publishSchedule.success) {
    throw new Error(data.publishSchedule.error?.message ?? 'Schedule could not be published.');
  }
});
